import styled from 'styled-components';

import { color, ColorProps } from 'styled-system';
import { Colors } from 'theme/colors';

export const DateItem = styled.div<ColorProps>`
  text-align: center;
  padding: 0.8rem 0.625rem 0.8rem;
  font-weight: 300;
  border-radius: 50rem;
  background-color: ${Colors.white};
  ${color}

  &:not(.rdtActive):hover {
    background: #eeeeee;
    cursor: pointer;
  }
`;
